import {mapActions, mapGetters} from 'vuex';
import tokenUtils from '@/utils/tokens';
import audioPlayer from '../audio-player/index.vue'
// import cancelTest from '../../popups/cancel-test/index.vue'

const HOME_WORK_COMMENT_BROADCAST = 'user_home_work_has_been_commented_by_admin_broadcast';
const GRADUATE_WORK_COMMENT_BROADCAST = 'user_graduate_work_has_been_commented_by_admin_broadcast';

export default {
    components: {
        audioPlayer,
        // cancelTest
    },
    props: {
        messages: {
            type: Array,
            default: []
        },
        typeWork: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            comment: "",
            uploadFile: null,
            fileLoading: false,
            messageLoading: false,
            echoChannelName: null,
            echoNotificationHandler: null,
            echoUnwatchUser: null,
        }
    },
    computed: {
        ...mapGetters({
            user: `user/user`,
        }),
        userId() {
            return this.user && this.user.id;
        },
    },
    mounted() {
        this.echoUnwatchUser = this.$store.watch(
            () => this.userId,
            () => {
                this.subscribeToCommentsBroadcast();
            },
            {immediate: true}
        );
    },
    beforeDestroy() {
        if (this.echoUnwatchUser) {
            this.echoUnwatchUser();
        }

        this.unsubscribeFromCommentsBroadcast();
    },
    methods: {
        ...mapActions({
            getFile: 'courses/GET_FILE',
            sendHomeWorkComment: 'coursesHomeWork/SEND_COMMENT',
            sendHomeWorkCommentFile: 'coursesHomeWork/SEND_COMMENT_FILE',
            sendGraduateWorkComment: 'coursesGraduateWork/SEND_COMMENT',
            sendGraduateWorkCommentFile: 'coursesGraduateWork/SEND_COMMENT_FILE',
            fetchHomeWorkItem: 'coursesHomeWork/GET_LIST_ITEM',
            fetchGraduateWorkItem: 'coursesGraduateWork/GET_LIST_ITEM',
        }),
        ensureEchoAuthHeaders() {
            if (!window.Echo || !window.Echo.connector || !window.Echo.connector.pusher) {
                return false;
            }

            const config = window.Echo.connector.pusher.config;

            if (!config.auth) {
                config.auth = {};
            }

            if (!config.auth.headers) {
                config.auth.headers = {};
            }

            config.auth.headers.Authorization = 'Bearer ' + tokenUtils.getActualToken();

            return true;
        },
        subscribeToCommentsBroadcast() {
            if (!this.userId || !process.env.VUE_APP_PUSHER_APP_KEY) {
                return;
            }

            if (!this.ensureEchoAuthHeaders()) {
                return;
            }

            const channelName = `users.${this.userId}`;

            if (this.echoChannelName === channelName) {
                return;
            }

            this.unsubscribeFromCommentsBroadcast();

            this.echoNotificationHandler = (event) => {
                this.handleIncomingCommentNotification(event);
            };

            window.Echo
                .private(channelName)
                .notification(this.echoNotificationHandler);

            this.echoChannelName = channelName;
        },
        unsubscribeFromCommentsBroadcast() {
            if (!this.echoChannelName || !window.Echo) {
                return;
            }

            window.Echo.leave(`private-${this.echoChannelName}`);
            this.echoChannelName = null;
            this.echoNotificationHandler = null;
        },
        handleIncomingCommentNotification(event) {
            if (this.typeWork === 'home work') {
                if (event.template_key && event.template_key !== HOME_WORK_COMMENT_BROADCAST) {
                    return;
                }

                if (!this.matchesHomeWorkNotification(event)) {
                    return;
                }

                this.refreshHomeWorkComments();
                return;
            }

            if (this.typeWork === 'graduate work') {
                if (event.template_key && event.template_key !== GRADUATE_WORK_COMMENT_BROADCAST) {
                    return;
                }

                this.refreshGraduateWorkComments();
            }
        },
        matchesHomeWorkNotification(event) {
            const route = this.$route.params;

            if (event.course_slug && route.item && event.course_slug !== route.item) {
                return false;
            }

            if (event.module_slug && route.moduleSlug && event.module_slug !== route.moduleSlug) {
                return false;
            }

            if (event.home_work_slug && route.testId && event.home_work_slug !== route.testId) {
                return false;
            }

            return true;
        },
        refreshHomeWorkComments() {
            const route = this.$route.params;

            if (!route.item || !route.moduleSlug || !route.testId) {
                return;
            }

            this.fetchHomeWorkItem({
                item: route.item,
                moduleSlug: route.moduleSlug,
                testId: route.testId,
            });
        },
        refreshGraduateWorkComments() {
            const route = this.$route.params;

            if (!route.item) {
                return;
            }

            this.fetchGraduateWorkItem({
                courseSlug: route.item,
            });
        },
        checkAuthor(id) {
            return id === this.user.id
                ? "message client-message"
                : "message admin-message";
        },
        renderMessage(message) {
            this.messages.push(message);
            this.$nextTick(() => {
                let area = document.getElementsByClassName("messagearea")[0];
                area.scrollTo(0, area.scrollHeight);
            });
        },
        sendMessage() {
            // e.preventDefault;
            if (this.comment) {
                const objMessage = {
                    comment: this.comment,
                    type: 'text'
                };
                this.messageLoading = true
                if (this.typeWork === 'home work') {
                    this.sendHomeWorkComment({...this.$route.params, comment: objMessage}).then(response => {
                        const data = response.data.data
                        this.messageLoading = false
                        this.renderMessage(data)
                    })
                } else if (this.typeWork === 'graduate work') {
                    this.sendGraduateWorkComment({...this.$route.params, comment: objMessage}).then(response => {
                        const data = response.data.data
                        this.messageLoading = false
                        this.renderMessage(data)
                    })
                }
                this.comment = "";
            }
        },
        addFile(file) {
            if (file) {
                this.uploadFile = file.target.files[0]
                const formData = new FormData();

                formData.append('src', this.uploadFile);
                formData.append('type_id', '2');
                formData.append('entity', 'comment');
                formData.append('service', 'course')

                this.getFile(formData).then(response => {
                    const file = response.data.data
                    const objectFile = {
                        comment: file.src,
                        type: 'file'
                    }
                    this.fileLoading = true
                    if (this.typeWork === 'home work') {
                        this.sendHomeWorkCommentFile({...this.$route.params, file: objectFile}).then(response => {
                            const data = response.data.data
                            this.fileLoading = false
                            this.renderMessage(data)
                        })
                    } else if (this.typeWork === 'graduate work') {
                        this.sendGraduateWorkCommentFile({...this.$route.params, file: objectFile}).then(response => {
                            const data = response.data.data
                            this.fileLoading = false
                            this.renderMessage(data)
                        })
                    }
                })
            }
        },
    }
}
